import "./es.object.assign-7e79fd7b.js";
import { BREAKPOINTS as u } from "@ucl/shared-component-foundations";
import { c as L } from "./index-8b07dec9.js";
import a, { css as e } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as W } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as v } from "./useWindowSize.js";
import { hTag as d } from "./hTag.js";
import { Image as T } from "./image.js";
import { c as y } from "./childrenCountCheck-bbe924c6.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import "./es.symbol.description-6025a604.js";
import { jsx as r, jsxs as s, Fragment as M } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
var N = /* @__PURE__ */ a.div.withConfig({
  displayName: "marketingDataListItem__MarketingListItemWrapper",
  componentId: "sc-1md6ca0-0"
})(["", ";"], function(i) {
  var t = i.theme.components.marketingDataList;
  return e(t.MarketingListItemWrapper);
}), b = /* @__PURE__ */ a.div.withConfig({
  displayName: "marketingDataListItem__ValueTextWrapper",
  componentId: "sc-1md6ca0-1"
})(["", ";"], function(i) {
  var t = i.theme.components.marketingDataList;
  return e(t.ValueTextWrapper);
}), w = /* @__PURE__ */ a(d).withConfig({
  displayName: "marketingDataListItem__Value",
  componentId: "sc-1md6ca0-2"
})(["", ";"], function(i) {
  var t = i.theme.components.marketingDataList;
  return e(t.Value);
}), C = /* @__PURE__ */ a.span.withConfig({
  displayName: "marketingDataListItem__Text",
  componentId: "sc-1md6ca0-3"
})(["", ";"], function(i) {
  var t = i.theme.components.marketingDataList;
  return e(t.Text);
}), _ = function(t) {
  var m = t.value, n = t.description, o = t.headingLevel, p = t.className;
  return /* @__PURE__ */ r(N, {
    className: p,
    children: /* @__PURE__ */ s(b, {
      children: [m && /* @__PURE__ */ r(w, {
        as: o || "h2",
        children: m
      }), n && /* @__PURE__ */ r(C, {
        children: n
      })]
    })
  });
}, x = /* @__PURE__ */ a.div.withConfig({
  displayName: "marketingDataList__MainWrapper",
  componentId: "fdv7y1-0"
})(["&.marketingDataList-mainWrapper{", ";}"], function(i) {
  var t = i.theme, m = t.componentStyles, n = t.components.marketingDataList;
  return e(n.MainWrapper, m);
}), S = /* @__PURE__ */ a.div.withConfig({
  displayName: "marketingDataList__MarketingListItemSection",
  componentId: "fdv7y1-1"
})(["", ";"], function(i) {
  var t = i.theme.components.marketingDataList;
  return e(t.MarketingListItemSection);
}), P = /* @__PURE__ */ a.div.withConfig({
  displayName: "marketingDataList__ImageWrapper",
  componentId: "fdv7y1-2"
})(["", ";"], function(i) {
  var t = i.theme.components.marketingDataList;
  return e(t.ImageWrapper);
}), j = /* @__PURE__ */ a.div.withConfig({
  displayName: "marketingDataList__ChildrenWrapper",
  componentId: "fdv7y1-3"
})(["", ";"], function(i) {
  var t = i.theme.components.marketingDataList;
  return e(t.ChildrenWrapper);
}), V = /* @__PURE__ */ a.div.withConfig({
  displayName: "marketingDataList__TitleSubTitleWrapper",
  componentId: "fdv7y1-4"
})(["", ";"], function(i) {
  var t = i.theme.components.marketingDataList;
  return e(t.TitleSubTitleWrapper);
}), z = /* @__PURE__ */ a(d).withConfig({
  displayName: "marketingDataList__TitleWrapper",
  componentId: "fdv7y1-5"
})(["&.titleWrapper{", ";}"], function(i) {
  var t = i.theme.components.marketingDataList;
  return e(t.TitleWrapper);
}), A = /* @__PURE__ */ a(d).withConfig({
  displayName: "marketingDataList__SubTitleWrapper",
  componentId: "fdv7y1-6"
})(["", ";"], function(i) {
  var t = i.theme.components.marketingDataList;
  return e(t.SubTitleWrapper);
}), F = function(t) {
  var m = t.children, n = t.className, o = t.titleProp, p = t.subTitleProp, g = t.imageProp, l = t.isImageRightAligned, k = t.dataTestId, D = W({
    label: "MarketingDataList"
  }), f = v(), I = f.width, c = v().width < u.tabletMin, h = function() {
    return /* @__PURE__ */ r(P, {
      children: /* @__PURE__ */ r(T, Object.assign({}, g, {
        ratio: I < u.tabletMin ? "3/2" : "1/1",
        objectFit: g.objectFit || "fill"
      }))
    });
  };
  return /* @__PURE__ */ s(M, {
    children: [y({
      additionalInfo: "Maximun data list items count exceeded. Max 6 list items allowed in a group for marketing data list.",
      children: m,
      componentName: "marketing data list",
      maxChildren: 6
    }), /* @__PURE__ */ s(x, Object.assign({
      className: L([["" + n, "marketingDataList-mainWrapper", {
        "marketingDataList-mainWrapper--right": l
      }]]),
      "data-testid": k
    }, D, {
      children: [(!l || c) && h(), /* @__PURE__ */ s(S, {
        children: [/* @__PURE__ */ s(V, {
          children: [o && /* @__PURE__ */ r(z, {
            as: o.headingLevel,
            className: L(["titleWrapper", "titleWrapper--" + (o.size || "extraLarge")]),
            children: o.title
          }), (p == null ? void 0 : p.subTitle) && /* @__PURE__ */ r(A, {
            as: p.headingLevel || "h2",
            children: p.subTitle
          })]
        }), /* @__PURE__ */ r(j, {
          children: m
        })]
      }), l && !c && h()]
    }))]
  });
};
F.Item = _;
export {
  F as MarketingDataList
};
